import styled from 'styled-components';
import { Collapse } from 'antd';

export const Div = styled.div`
    padding: 30px 90px; 

    @media screen and (max-width: 1500px) {
        
    }

    @media screen and (max-width: 768px) {
        padding: 30px 15px;
    }
`

export const DivTitle = styled.div`
text-align: center;
margin-bottom: 2%;
`

export const Title = styled.h1`
    color: #DF8232;
`

export const SubTitle = styled.p`
    font-size: 15px;
`

export const QuestionsCollapseta = styled(Collapse)`
 
`

const { Panel } = Collapse;
export const PanelQuestion = styled(Panel)`
    background: #DF8232;
    & > div.ant-collapse-header{
        color: #fff !important;
    }
`